var map = {
	"./ch.png": "000b",
	"./en.png": "6e4c",
	"./kr.png": "bfda",
	"./logo_vn_guide.png": "fef0",
	"./money-bag.png": "fce9",
	"./money.png": "b6a1",
	"./shopping-bag.png": "fc74",
	"./thumbnail-overlay.png": "e301",
	"./vi.png": "e173"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";